<section class="hotlist-widget" [class.empty]="!loading() && !error() && totalCount === 0" [class.loading]="loading()" [class.warning-only]="totalCount > 0 && !offlineCount && !errorCount" [attr.aria-label]="t()('hotlist.title')">
    <header class="hotlist-header">
        <h4>
            <i [class]="!loading() && !error() && totalCount === 0 ? 'fa fa-circle-check' : 'fa fa-triangle-exclamation'" aria-hidden="true"></i>
            {{ t()('hotlist.title') }}
            @if (!loading() && totalCount > 0) {
                <span class="issue-total">{{ totalCount }}</span>
            }
        </h4>
        @if (!loading() && !error() && totalCount > 0) {
            <div class="hotlist-summary">
                @if (offlineCount) {
                    <span class="summary-offline"><span class="summary-dot"></span>{{ offlineCount }} {{ t()('hotlist.offline') }}</span>
                }
                @if (errorCount) {
                    <span class="summary-error"><span class="summary-dot"></span>{{ errorCount }} {{ t()('hotlist.errors') }}</span>
                }
                @if (warningCount) {
                    <span class="summary-warning"><span class="summary-dot"></span>{{ warningCount }} {{ t()('hotlist.warnings') }}</span>
                }
            </div>
        }
    </header>

    <div class="hotlist-content" [attr.aria-busy]="loading()">
        @if (loading()) {
            <app-loading-skeleton preset="list" [count]="4" [label]="t()('hotlist.loading')" />
        } @else if (error()) {
            <app-empty-state icon="pi pi-exclamation-circle" tone="error" [title]="t()('hotlist.loadError')" [description]="error()" [compact]="true" [fill]="true" />
        } @else if (totalCount === 0) {
            <app-empty-state icon="pi pi-check-circle" tone="success" [title]="t()('hotlist.empty')" [description]="t()('hotlist.emptyDetail')" [compact]="true" [fill]="true" />
        } @else {
            <ul class="issues-list">
                @for (issue of displayedIssues; track $index) {
                    <li>
                        <a [routerLink]="['/device', issue.deviceId]" class="issue-item" [class.warning]="!isError(issue) && !issue.isOffline" [class.offline]="issue.isOffline">
                            <div class="issue-identity">
                                <span class="issue-icon">
                                    @if (issue.isOffline) {
                                        <i class="fa fa-plug-circle-xmark" aria-hidden="true"></i>
                                    } @else if (isCheckInHealth(issue)) {
                                        <i class="fa fa-database" aria-hidden="true"></i>
                                    } @else if (isError(issue)) {
                                        <i class="fa fa-circle-xmark" aria-hidden="true"></i>
                                    } @else {
                                        <i class="fa fa-triangle-exclamation" aria-hidden="true"></i>
                                    }
                                </span>
                                <span class="issue-device">{{ issue.deviceName }}</span>
                            </div>
                            <div class="issue-details">
                                <div class="issue-message">{{ issue.message }}</div>
                                @if (issue.details) {
                                    <div class="issue-extra">{{ issue.details }}</div>
                                }
                            </div>
                            <div class="issue-meta">
                                <span class="issue-status">{{ t()(issue.isOffline ? 'hotlist.offline' : isError(issue) ? 'hotlist.error' : 'hotlist.warning') }}</span>
                                @if (issue.time && formatTime(issue.time); as time) {
                                    <time [attr.datetime]="issue.time" [title]="issue.time">{{ time }}</time>
                                }
                                @if (isCheckInHealth(issue)) {
                                    <span class="issue-source">{{ t()('hotlist.cloudStorage') }}</span>
                                }
                                @if (issue.publisherName) {
                                    <span class="issue-source">{{ issue.publisherName }}</span>
                                }
                            </div>
                            <span class="issue-open" [title]="t()('hotlist.viewSystem')"
                                ><i class="fa fa-arrow-right" aria-hidden="true"></i><span class="sr-only">{{ t()('hotlist.viewSystem') }}</span></span
                            >
                        </a>
                    </li>
                }
            </ul>
        }
    </div>
    @if (!loading() && !error() && hasMore) {
        <footer class="hotlist-footer">
            <button type="button" class="more-button" [attr.aria-expanded]="expanded()" (click)="expanded.set(!expanded())">
                {{ t()(expanded() ? 'hotlist.showLess' : 'hotlist.showAll') }}
                @if (!expanded()) {
                    <span class="more-count">+{{ hiddenCount }}</span>
                }
                <i [class]="expanded() ? 'fa fa-angle-up' : 'fa fa-angle-down'" aria-hidden="true"></i>
            </button>
        </footer>
    }
</section>
